<div class="animated fadeIn fast">
  
  <div class="row">
    <div class="col-9">
      <h1 class="mat-fit font-text">{{viewTitle}}</h1>
    </div>
  </div>
  
  <mat-divider></mat-divider>
  <br>

  <div class="details" *ngIf="showForm">
    
      
    <div class="csv-visibility" *ngIf="loadCsv">
      <div class="row">
        <div class="col-5 content-left">
          <h2 class="font-text" style="margin: 0px;">Crear a partir de archivo Excel</h2>
          <p class="font-text" style="color: var(--primary-m-gray);">
            seleccione un archivo .xlsx ó .xls para crear.
          </p>
        </div>
    
        <div class="col-6 content-right">
          <div class="row">
            <div class="content-bulk">
              <p style="margin: 0px;">
                    {{fileName}}
              </p>
  
              <div class="bluk-load">
                <input #fileInput #csvInput hidden="true" type="file" accept=".xlsx, .xls" (change)="onFileChange($event)"/>
                <div class="content-info">
                  <button 
                    mat-stroked-button 
                    color="accent" 
                    class="button-categories font-text" 
                    (click)="csvInput.click()"
                  >
                        Seleccione un archivo para carga masiva<mat-icon>file_upload</mat-icon>
                  </button>
  
                  <button 
                    mat-stroked-button 
                    color="accent" 
                    class="button-upload" 
                    (click)="sendFileToBulk()"
                    [disabled]="disabledSendBulkButton"
                  >
                    Guardar <mat-icon>save</mat-icon>
                  </button>
                  <div class="space"></div>
                  <div class="loader" *ngIf="isLoading">Loading...</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
      <br>
      <div class="or-divider">
        <div class="right-line col-sm-5"></div>
        <div class="center-line col-sm-2 text-center">O</div>
        <div class="left-line col-sm-5"></div>
      </div>

      <br>
    </div>

    <form autocomplete="off" [formGroup]="poiForm">

      <div class="row">
        <div class="col-5 content-left font-text">
          <h2 style="margin: 0px;">Información de posicionamiento</h2>
          <p style="color: var(--primary-m-gray);">
            Información de la posición en el mapa. Introduzca los campos requeridos (*) para agregar.
          </p>
        </div>
    
        <div class="col-6 content-right">
          <div class="row">
            <div class="col-6">
              <google-map class="map-position" [center]="center" [zoom]="zoom" [options]="mapOptions">
                <map-marker *ngFor="let poi of poisList; let i = index" 
                  [position]="{ lat: poi.lat!, lng: poi.lng! }"
                  [options]="markerOptions" (mapDragend)="onDragendHandler($event)">
                </map-marker>
              </google-map>
            </div>
            <div class="col-6">
              <mat-form-field class="col-sm-12" appearance="fill">
                <mat-label>Latitud</mat-label>
                <input required matInput formControlName="lat">
              </mat-form-field>
    
              <mat-form-field class="col-sm-12" appearance="fill">
                <mat-label>Longitud</mat-label>
                <input required matInput formControlName="lng">
              </mat-form-field>
    
              <mat-form-field class="col-sm-12" appearance="fill">
                <mat-label>Ubicación</mat-label>
                <input matInput formControlName="ubicacion">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <br>


      <div class="row">
        <div class="col-5 content-left font-text">
          <h2 style="margin: 0px;">Información general</h2>
          <p style="color: var(--primary-m-gray);">
            Introduzca los campos requeridos (*) para agregar.
          </p>
        </div>
        
        <div class="col-6 content-right">
          
    
            <div class="row" *ngIf="isParentCategory">
              <mat-form-field class="col-xs-12 col-md-5 font-text" appearance="fill">
                <mat-label>ID de la Categoría</mat-label>
                <input 
                  matInput 
                  required
                  formControlName="categoryId"
                >
              </mat-form-field>
            </div>

            <div class="row" *ngIf="!isParentCategory">
              <mat-form-field class="col-xs-12 col-md-5 font-text" appearance="fill">
                <mat-label>ID</mat-label>
                <input 
                  matInput 
                  required
                  formControlName="categoryId"
                >
              </mat-form-field>
            </div>
            
            <div class="row">
              <mat-form-field class="col-xs-12 col-md-12 font-text" appearance="fill">
                <mat-label>Nombre</mat-label>
                <input 
                  matInput 
                  required 
                  formControlName="nombre"
                >
              </mat-form-field>
            </div>
          
            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Dirección completa</mat-label>
              <input 
                matInput
                formControlName="direccionCompleta"
              >
            </mat-form-field>

            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Tipo vía</mat-label>
              <input matInput formControlName="tipoVia">
            </mat-form-field>
    
            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Comuna</mat-label>
              <input matInput formControlName="comuna">
            </mat-form-field>

            <div class="row">
              <mat-form-field class="col-sm-6 font-text" appearance="fill">
                <mat-label>Ciudad</mat-label>
                <input matInput formControlName="ciudad">
              </mat-form-field>
  
              <mat-form-field class="col-sm-6 font-text" appearance="fill">
                <mat-label>Región</mat-label>
                <input matInput formControlName="region">
              </mat-form-field>
            </div>
    
    
            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Razón Social</mat-label>
              <input matInput formControlName="razonSocial">
            </mat-form-field>
    
            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Rut/Ruc</mat-label>
              <input matInput formControlName="rutRuc">
            </mat-form-field>
    
            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Local</mat-label>
              <input matInput formControlName="local">
            </mat-form-field>
    
            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Especialidad</mat-label>
              <input matInput formControlName="especialidad">
            </mat-form-field>

            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Observación</mat-label>
              <textarea 
                matInput 
                style="min-height: 100px;" 
                formControlName="observacion">
              </textarea>
            </mat-form-field>
    
            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Observación interna</mat-label>
              <textarea 
                matInput 
                style="min-height: 100px;" 
                formControlName="observacionesInternas">
              </textarea>
            </mat-form-field>

            <mat-form-field class="col-sm-12 font-text" appearance="fill" *ngIf="false">
              <mat-label>Otros datos</mat-label>
              <input matInput formControlName="otrosDatos">
            </mat-form-field>

        </div>
      </div>
      <br>

      <div class="row">
        <div class="col-5 content-left font-text">
          <h2 style="margin: 0px;">Información de contacto</h2>
          <p style="color: var(--primary-m-gray);">
            Introduzca los campos requeridos (*) para agregar.</p>
        </div>
    
        <div class="col-6 content-right">
          <div class="row">
            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Fax</mat-label>
              <input matInput formControlName="fax">
            </mat-form-field>

            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Web</mat-label>
              <input matInput formControlName="web">
            </mat-form-field>

            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>E-mail</mat-label>
              <input matInput formControlName="email" [pattern]="emailPattern">
            </mat-form-field>

            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Url fuente</mat-label>
              <input matInput formControlName="urlFuente">
            </mat-form-field>
    
            <mat-form-field class="col-sm-12 font-text" appearance="fill">
              <mat-label>Web fuente</mat-label>
              <input matInput formControlName="webFuente">
            </mat-form-field>
          </div>
        </div>
      </div>
      <br>

      <div class="row">
        <div class="col-5 content-left font-text">
          <h2 style="margin: 0px;">Otros datos</h2>
          <p style="color: var(--primary-m-gray);">
            Introduzca los campos requeridos (*) para agregar.</p>
        </div>

        <div class="col-6 content-right">

          <div class="row">

              <mat-form-field class="col-sm-12 font-text" appearance="fill">
                <mat-label>Página web</mat-label>
                <input matInput [formControl]="paginaWeb">
              </mat-form-field>

              <mat-form-field class="col-sm-12 font-text" appearance="fill">
                <mat-label>E-mail</mat-label>
                <input matInput [formControl]="email" [pattern]="emailPattern">
              </mat-form-field>

          </div>
          
          <mat-divider></mat-divider>
          <br>

          <div class="row">
            <div class="row">
              <div
                *ngFor="let telefono of telefonos['controls']; let i = index;">
                <div class="row">
                  <div class="row gy-2">
                    <mat-form-field class="col-sm-6 font-text" appearance="fill">
                      <mat-label>Teléfono</mat-label>
                      <input matInput [formControl]="getDynamicByIndex(telefonos, i)">
                    </mat-form-field>

                    <div class="col-6">
                      <button
                        mat-stroked-button
                        color="accent"
                        class="button-upload float-end"
                        (click)="moveUp(telefonos, i)"
                        *ngIf="i > 0"
                      >
                        <mat-icon>arrow_upward</mat-icon>
                      </button>

                      <button
                        mat-stroked-button
                        color="accent"
                        class="button-upload float-end"
                        (click)="moveDown(telefonos, i)"
                        *ngIf="i < telefonos['controls'].length - 1"
                      >
                        <mat-icon>arrow_downward</mat-icon>
                      </button>

                      <button
                        mat-stroked-button
                        color="accent"
                        class="button-upload float-end"
                        (click)="deleteDynamic(telefonos, i)"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-around gy-3">
                <button
                  mat-stroked-button
                  color="accent"
                  class="button-upload float-end col-5 font-text"
                  (click)="addDynamic(telefonos, '')"
                >
                  Agregar teléfono<mat-icon>local_phone</mat-icon>
                </button>

                <button
                mat-stroked-button
                  color="accent"
                  class="button-upload float-end col-5 font-text"
                  *ngIf="telefonos['controls'].length > 0"
                  (click)="deleteAllDynamic(telefonos)"
                >
                  Borrar todo<mat-icon>delete_sweep</mat-icon>
                </button>
              </div>
            </div>

            <div class="row">
              <div *ngFor="let especialidad of especialidades['controls']; let i = index;">
                <div class="row">
                  <div class="row gy-2">
                    <mat-form-field class="col-sm-6 font-text" appearance="fill">
                      <mat-label>Especialidad</mat-label>
                      <input matInput [formControl]="getDynamicByIndex(especialidades, i)">
                    </mat-form-field>

                    <div class="col-6">
                      <button
                        mat-stroked-button
                        color="accent"
                        class="button-upload float-end"
                        (click)="moveUp(especialidades, i)"
                        *ngIf="i > 0"
                      >
                        <mat-icon>arrow_upward</mat-icon>
                      </button>
      
                      <button
                        mat-stroked-button
                        color="accent"
                        class="button-upload float-end"
                        (click)="moveDown(especialidades, i)"
                        *ngIf="i < especialidades['controls'].length - 1"
                      >
                        <mat-icon>arrow_downward</mat-icon>
                      </button>
      
                      <button
                      mat-stroked-button
                        color="accent"
                        class="button-upload float-end"
                        (click)="deleteDynamic(especialidades, i)"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
      
                    </div>
                  </div>
                  <br>
                </div>
              </div>

              <div class="row justify-content-around gy-3">
                <button
                  mat-stroked-button
                  color="accent"
                  class="button-upload float-end col-5 font-text"
                  (click)="addDynamic(especialidades, '')"
                >
                  Agregar especialidad<mat-icon>class</mat-icon>
                </button>

                <button
                  mat-stroked-button
                  color="accent"
                  class="button-upload float-end col-5 font-text"
                  *ngIf="especialidades['controls'].length > 0"
                  (click)="deleteAllDynamic(especialidades)"
                >
                  Borrar todo<mat-icon>delete_sweep</mat-icon>
                </button>
              </div>
            </div>

            <div class="row">
              <div *ngFor="let horario of horarios['controls']; let i = index;">
                <div class="row">
                  <div class="row gy-2">
                    <mat-form-field class="col-sm-6 font-text" appearance="fill">
                      <mat-label>Horario</mat-label>
                      <input matInput [formControl]="getDynamicByIndex(horarios, i)">
                    </mat-form-field>

                    <div class="col-6">
                      <button
                        mat-stroked-button
                        color="accent"
                        class="button-upload float-end"
                        (click)="moveUp(horarios, i)"
                        *ngIf="i > 0"
                      >
                        <mat-icon>arrow_upward</mat-icon>
                      </button>
      
                      <button
                        mat-stroked-button
                        color="accent"
                        class="button-upload float-end"
                        (click)="moveDown(horarios, i)"
                        *ngIf="i < horarios['controls'].length - 1"
                      >
                        <mat-icon>arrow_downward</mat-icon>
                      </button>
      
                      <button
                        mat-stroked-button
                        color="accent"
                        class="button-upload float-end"
                        (click)="deleteDynamic(horarios, i)"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <br>
                </div>
              </div>

              <div class="row justify-content-around gy-3">
                <button
                  mat-stroked-button
                  color="accent"
                  class="button-upload float-end col-5 font-text"
                  (click)="addDynamic(horarios, '')"
                >
                  Agregar horario <mat-icon>alarm</mat-icon>
                </button>
                
                <button
                  mat-stroked-button
                  color="accent"
                  class="button-upload float-end col-5 font-text"
                  *ngIf="horarios['controls'].length > 0"
                  (click)="deleteAllDynamic(horarios)"
                >
                  Borrar todo<mat-icon>delete_sweep</mat-icon>
                </button>
              </div>
            </div>

            <div class="row gy-4">

            </div>
            <mat-divider></mat-divider>
            
            <div class="row gy-3">
              <button 
                mat-stroked-button 
                class="button-upload col-1" 
                color="accent" aria-label="View" 
                matTooltip="Volver al inicio"
                [routerLink]="['/', 'category', parentIdValue]"
              >
                <mat-icon>arrow_circle_left</mat-icon>
              </button>

              <button 
                mat-stroked-button 
                color="accent" 
                class="button-save col-2 font-text"
                [disabled]="!poiForm.valid"
                (click)="save()"
              >
                Guardar <mat-icon>save</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
</form>
</div>